import React from "react"
import { ImgTextCustomContainer, ImgWrapper, TextWrapper } from "./style"
import { ReactComponent as Arrow } from "images/icons/right-arrow.svg"
import AvenueLink from "components/AvenueLink"
import AvenueImg from "components/AvenueImg"

const ImgTextCustom = ({ img, link, heading, message }) => {
  
  const wpImg = {
    sourceUrl: img.sourceurl,
    srcSet: img.srcset,
    sizes: "100vw",
    aspectRatio: 1,
  }

  return (
    <ImgTextCustomContainer>
      <ImgWrapper>
        <AvenueImg fluid={wpImg} />
      </ImgWrapper>

      <TextWrapper>
        <h3>
          <AvenueLink to={link}>{heading}</AvenueLink>
        </h3>
        <p>{message}</p>
        <Arrow />
      </TextWrapper>
    </ImgTextCustomContainer>
  )
}

export default ImgTextCustom
